import * as types from '../../mutation-types'

// Mock用户数据（仅在开发环境使用）
const mockUser = process.env.REACT_APP_USE_MOCK === 'true' ? {
  id: 'mock_user_001',
  username: 'demo_user',
  nickname: 'Demo用户',
  avatar: 'avatar/Logo_1713450616627.png',
  email: 'demo@metahub.com',
  phone: '138****8888',
  gender: 1,
  introduction: '这是一个Mock测试用户，用于开发环境演示',
  createTime: '2024-01-01 00:00:00'
} : null;

const mockToken = process.env.REACT_APP_USE_MOCK === 'true' ? 'mock_token_' + Date.now() : '';

// 初始用户状态
const initialState = {
  userInfo: mockUser,
  token: mockToken,
  isLogin: !!mockUser,
  showLogin: false,
  follows: [],
  fans: [],
  notifications: []
};

// 用户reducer函数
const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_TOKEN:
      // 处理登录action
      return {
        ...state,
        token: action.token,
        isLogin: true,
      }
    case types.SET_USER:
      // 处理登录action
      return {
        ...state,
        userInfo: action.userInfo,
      };
    case types.LOGIN:
      // 处理登录action
      return {
        ...state,
        isLogin: true,
      };
    case types.LOGOUT:
      // 处理登出action
      return {
        ...state,
        token: '',
        userInfo: null,
        isLogin: false,
        follows: [],
        fans: [],
        notifications: []
      };
    case types.SET_SHOW_LOGIN:
      // 处理登录action
      return {
        ...state,
        showLogin: action.status,
      };
    case types.SET_FOLLOWS:
      return {
        ...state,
        follows: action.follows,
      }
    case types.SET_FANS:
      return {
        ...state,
        fans: action.fans,
      }
    case types.SET_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.notifications,
      }
    default:
      // 对于未知的action类型，返回当前的state
      return state
  }
};

export default userReducer;